// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608270704/js/" + chunkId + "." + {"44":"9dac315d","225":"3619dbb6","481":"3e60e2dd","486":"16039c41","770":"9f1fdad3"}[chunkId] + ".0.6820255980417964.chunk.js";
};